exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid_listing .product-listing-content h5{line-height:26px;font-size:16px;margin:0 auto}.label_icon{background:rgba(0,0,0,.8392156862745098);font-weight:700;font-size:16px}p.list-price{font-size:14px!important}h5.a-title{width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.grid_listing .product-listing-content{padding:10px 10px 0}ul.features_list{margin-top:0!important}ul.features_list>li{text-align:center}.page-item.active .page-link{z-index:3;color:#fff;background-color:#d3d3d3;border-color:#d3d3d3}.page-link{color:#161a1d}", ""]);

// exports
